import React from 'react';
import './css/addNewCertificateCard.scss';
import { BsPlusLg } from '../../../../components/icons';
const AddCertificate = ({ clsName, gtmTagVariable }) => {
  return (
    <div
      className={`addNewCertificateCard shadow rounded d-flex flex-column align-items-center justify-content-center transition cursorPointer border border-primary bg-primary bg-opacity-10 py-20 px-4 ${clsName}  ${gtmTagVariable}_addcertificate`}
    >
      <div className="rounded-circle mb-4 addNewCertificateCircle d-inline-flex align-items-center justify-content-center transition bg-primary border border-5">
        <BsPlusLg
          customClass={`fs-2 text-white ${gtmTagVariable}_addcertificate_icon`}
          gtmTagVariable={`${gtmTagVariable}_addcertificate`}
        />
      </div>

      <h5 className={`text-black fs-16 transition  ${gtmTagVariable}_addcertificate`}>
        Add new Certificate
      </h5>
    </div>
  );
};

export default AddCertificate;
